import {
  Box,
  Button,
  Collapse,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Divider from "@mui/material/Divider";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Grid from "@mui/material/Unstable_Grid2";
import DoctorInfo from "./DoctorInfo";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";
import { useMediaQuery } from "@mui/material";
import ImageGallery from "react-image-gallery";
import "../images-gallery.css";

function useResponsiveCollapsedSize() {
  const isXs = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const isSm = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  if (isXs) {
    return 375;
  } else if (isSm) {
    return 375;
  } else {
    return 285;
  }
}

const BranchItem = ({
  name,
  address,
  phoneNumber,
  locationUrl,
  bookAttributes,
  doctors,
  imagesGalleryUrls,
  officeHours,
  position,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const handleShowDetails = () => {
    setShowDetails((prev) => !prev);
  };

  const handleShowMore = () => {
    setShowMore((prev) => !prev);
  };

  const collapsedSize = useResponsiveCollapsedSize();

  const customProps = {};
  if (bookAttributes && bookAttributes.length > 0) {
    const lines = bookAttributes.split(" ");
    lines.forEach((line) => {
      const [key, value] = line.split("|");
      customProps[key] = value;
    });
  }

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "25px",
        padding: "24px 28px 24px 24px",
        backgroundColor: "rgb(245 245 245 / 67%)",
      }}
    >
      <Stack spacing={2}>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <LocationOnIcon
              sx={{ mr: 1, fontSize: { xs: "1rem", sm: "1.25rem" } }}
            />
            <Typography
              sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              variant="h6"
            >
              {name}
            </Typography>
          </Box>
        </Box>
        <Divider
          variant="middle"
          sx={{ maxWidth: "100%", borderColor: "rgb(0 0 0 / 56%)" }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Typography
            sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
            variant="subtitle2"
          >
            {address}
          </Typography>
          <Button
            href={`tel:${phoneNumber}`}
            variant="outlined"
            startIcon={<LocalPhoneIcon />}
            sx={{
              borderRadius: "25px",
              mt: { xs: 1, sm: 0 },
              fontSize: { xs: "0.7rem", sm: "0.875rem" },
            }}
          >
            {phoneNumber}
          </Button>
        </Box>
        <Collapse in={showDetails}>
          <Box sx={{ pt: 3 }}>
            <Grid container spacing={2}>
              <Grid xs={12} md={5}>
                <Box
                  sx={{
                    border: "1px solid #47ABFF",
                    borderRadius: "25px",
                    padding: "12px 18px 24px 15px",
                    backgroundColor: "#FAFAFA",
                  }}
                >
                  <Typography variant="subtitle1">Office Hours</Typography>
                  <Divider
                    sx={{ maxWidth: "100%", borderColor: "rgb(0 0 0 / 56%)" }}
                  />
                  <List>
                    {officeHours.map((day, i) => {
                      return (
                        <ListItem key={i} disablePadding sx={{ my: 1 }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Typography
                              sx={{ fontWeight: "400" }}
                              variant="subtitle2"
                            >
                              {day.day}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                              }}
                            >
                              {day.start_time === "Closed" && (
                                <Typography
                                  sx={{
                                    color: "#0B3C65",
                                    fontWeight: "600",
                                    width: "100%",
                                  }}
                                  variant="subtitle2"
                                >
                                  Closed
                                </Typography>
                              )}
                              {day.start_time !== "Closed" && (
                                <>
                                  <Typography
                                    sx={{
                                      color: "#0B3C65",
                                      fontWeight: "600",
                                      fontSize: {
                                        xs: "0.77rem",
                                        sm: "0.875rem",
                                      },
                                    }}
                                    variant="subtitle2"
                                  >
                                    {day.start_time}
                                  </Typography>
                                  <Typography
                                    sx={{ mx: 1 }}
                                    variant="subtitle2"
                                  >
                                    to
                                  </Typography>
                                  <Typography
                                    sx={{
                                      color: "#0B3C65",
                                      fontWeight: "600",
                                      fontSize: {
                                        xs: "0.77rem",
                                        sm: "0.875rem",
                                      },
                                    }}
                                    variant="subtitle2"
                                  >
                                    {day.end_time}
                                  </Typography>
                                </>
                              )}
                            </Box>
                          </Box>
                        </ListItem>
                      );
                    })}
                  </List>
                </Box>
              </Grid>
              {imagesGalleryUrls.length > 0 && (
                <Grid xs={12} md={7}>
                  <Box
                    sx={{
                      borderRadius: "25px",
                      padding: "12px 18px 24px 15px",
                    }}
                  >
                    {/*<Typography variant="subtitle1">Doctors</Typography>*/}
                    <Typography variant="subtitle1">
                      Branch Photo gallery
                    </Typography>
                    <Divider
                      sx={{ maxWidth: "100%", borderColor: "rgb(0 0 0 / 56%)" }}
                    />
                    <Box sx={{ pt: 2 }}>
                      <Box sx={{ borderRadius: "25px" }}>
                        <ImageGallery
                          items={imagesGalleryUrls}
                          showFullscreenButton={false}
                          showThumbnails={false}
                          showIndex={false}
                          showPlayButton={true}
                        />
                      </Box>
                      {/*<Collapse in={showMore} collapsedSize={collapsedSize}>*/}
                      {/*  <Grid container spacing={2}>*/}
                      {/*    {doctors.slice(0, 4).map((doctor, i) => {*/}
                      {/*      return (*/}
                      {/*        <Grid*/}
                      {/*          xs={12}*/}
                      {/*          sm={6}*/}
                      {/*          key={i}*/}
                      {/*          sx={{ maxHeight: "180px" }}*/}
                      {/*        >*/}
                      {/*          <DoctorInfo*/}
                      {/*            name={doctor.name}*/}
                      {/*            desc={doctor.desc}*/}
                      {/*            profileUrl={doctor.profileUrl}*/}
                      {/*            imageUrl={doctor.imageUrl}*/}
                      {/*          />*/}
                      {/*        </Grid>*/}
                      {/*      );*/}
                      {/*    })}*/}
                      {/*    {doctors.slice(4).map((doctor, i) => {*/}
                      {/*      return (*/}
                      {/*        <Grid xs={12} sm={6} key={i}>*/}
                      {/*          <DoctorInfo*/}
                      {/*            name={doctor.name}*/}
                      {/*            desc={doctor.desc}*/}
                      {/*            imageUrl={doctor.imageUrl}*/}
                      {/*          />*/}
                      {/*        </Grid>*/}
                      {/*      );*/}
                      {/*    })}*/}
                      {/*  </Grid>*/}
                      {/*</Collapse>*/}
                    </Box>
                    {/*{doctors.length > 4 && (*/}
                    {/*  <Box*/}
                    {/*    sx={{ display: "flex", justifyContent: "center", pt: 1 }}*/}
                    {/*  >*/}
                    {/*    <Button*/}
                    {/*      size="small"*/}
                    {/*      startIcon={*/}
                    {/*        showMore ? (*/}
                    {/*          <KeyboardArrowUpIcon />*/}
                    {/*        ) : (*/}
                    {/*          <KeyboardArrowDownIcon />*/}
                    {/*        )*/}
                    {/*      }*/}
                    {/*      variant="text"*/}
                    {/*      onClick={handleShowMore}*/}
                    {/*    >*/}
                    {/*      {showMore ? "Show Less" : "Show More"}*/}
                    {/*    </Button>*/}
                    {/*  </Box>*/}
                    {/*)}*/}
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Collapse>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Button
              size="small"
              startIcon={
                showDetails ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              variant="text"
              onClick={handleShowDetails}
              sx={{ fontSize: { xs: "0.5125rem", sm: "0.8125rem" } }}
            >
              {showDetails ? "Close Details" : "Details"}
            </Button>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Button
              variant="text"
              sx={{
                fontWeight: 600,
                mr: { xs: 0, sm: 2 },
                fontSize: { xs: "0.55rem", sm: "0.875rem" },
                whiteSpace: "nowrap",
              }}
              href={locationUrl}
              target="_blank"
            >
              Visit Location
            </Button>
            <Button
              color="yellow"
              variant="contained"
              sx={{
                borderRadius: "25px",
                marginTop: "2px",
                fontWeight: 600,
                fontSize: { xs: "0.55rem", sm: "0.875rem" },
                whiteSpace: "nowrap",
              }}
              className="os_trigger_booking"
              href="#"
              {...customProps}
            >
              Book Online
            </Button>
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};

export default BranchItem;
